import { createFileRoute, notFound } from "@tanstack/react-router";
import { PregnancyWeekPage } from "@/components/pregnancy/PregnancyWeekPage";
import { getWeekPage } from "@/lib/pregnancy/week-data";
import { leafHead } from "@/lib/seo/leaf-head";
import { pregnancyPageScripts } from "@/lib/pregnancy/schemas";

export const Route = createFileRoute("/conception-calculator-week-{$week}")({
  loader: ({ params }) => {
    const w = Number((params as { week: string }).week);
    const data = getWeekPage("conception", w);
    if (!data) throw notFound();
    return data;
  },
  head: ({ loaderData }) => {
    if (!loaderData) {
      return { meta: [{ title: "Not found" }, { name: "robots", content: "noindex" }] };
    }
    return leafHead({ path: new URL(loaderData.meta.canonical).pathname, title: loaderData.meta.title, description: loaderData.meta.description, ogType: "article", scripts: pregnancyPageScripts(loaderData) });
  },
  component: WeekComp,
  notFoundComponent: () => (
    <div className="mx-auto max-w-lg p-8 text-center">
      <h1 className="text-2xl font-bold">Week not found</h1>
      <p className="mt-2 text-muted-foreground">Valid weeks are 1–42.</p>
    </div>
  ),
  errorComponent: () => (
    <div className="mx-auto max-w-lg p-8 text-center">
      <h1 className="text-2xl font-bold">Something went wrong</h1>
    </div>
  ),
});

function WeekComp() {
  const data = Route.useLoaderData();
  return <PregnancyWeekPage data={data} />;
}
